"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Color_1 = __importDefault(require("./Color"));
var validators_1 = require("./validators");
var helpers_1 = require("./helpers");
var ColorScale = /** @class */ (function () {
    function ColorScale(min, max, colorStops, alpha) {
        if (alpha === void 0) { alpha = 1; }
        (0, validators_1.validateMinMaxValues)(min, max);
        (0, validators_1.validateColorStops)(colorStops);
        (0, validators_1.validateAlphaValue)(alpha);
        this.min = min;
        this.max = max;
        this.alpha = alpha;
        this.colorStops = colorStops.map(function (colorStop) { return (0, helpers_1.hexToColor)(colorStop, alpha); });
        this.range = this.max - this.min;
    }
    ColorScale.prototype.getColor = function (value) {
        var numOfColorStops = this.colorStops.length;
        if (value < this.min)
            return this.colorStops[0];
        if (value > this.max)
            return this.colorStops[numOfColorStops - 1];
        var weight = (value - this.min) / this.range;
        var colorStopIndex = Math.max(Math.ceil(weight * (numOfColorStops - 1)), 1);
        var minColor = this.colorStops[colorStopIndex - 1];
        var maxColor = this.colorStops[colorStopIndex];
        weight = weight * (numOfColorStops - 1) - (colorStopIndex - 1);
        var r = Math.floor(weight * maxColor.r + (1 - weight) * minColor.r);
        var g = Math.floor(weight * maxColor.g + (1 - weight) * minColor.g);
        var b = Math.floor(weight * maxColor.b + (1 - weight) * minColor.b);
        return new Color_1.default(r, g, b, this.alpha);
    };
    return ColorScale;
}());
exports.default = ColorScale;
